import Icon from "../../Icon";
import styles from "./styles.module.scss";
import { motion } from "framer-motion";

const Quotes = () => {
  return (
    <div className="h-[40rem] bg-[#ebe3ce] flex justify-center items-center relative px-8 border-b border-b-[#8C7756] overflow-hidden">
      <div
        className={`absolute scale-50 -top-[71px] -left-[87px] sm:scale-[0.8] sm:-top-[23px] sm:-left-[40px] lg:scale-100 lg:top-[9px] lg:-left-3 rotate-90`}
      >
        <Icon iconName="leftQuotesFlower" />
      </div>

      {/* <div className="bg-red-400 w-8 h-8 absolute top-0 left-0"></div> */}

      <div
        className={`rotate-180 absolute scale-50 -top-[76px] -right-[87px] sm:scale-[0.8] sm:-top-[30px] sm:-right-[30px] lg:scale-100 lg:top-0 lg:-right-3`}
      >
        <Icon iconName="leftQuotesFlower" />
      </div>

      <div className="flex flex-col justify-center items-center w-full lg:w-3/4">
        {/* <motion.div
          initial={{ opacity: 1 }}
          whileInView={{
            opacity: 1,
            transition: {
              delayChildren: 1,
            },
          }}
          className="mb-2 text-center"
        >
          <motion.p
            initial={{
              y: 100,
            }}
            animate={{
              y: 0,
              transition: {
                delay: 0.5,
                duration: 0.8,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className="text-lg md:text-3xl xl:text-5xl font-calabassas"
          ></motion.p>
        </motion.div> */}

        <motion.div className="text-center">
          <motion.p
            initial={{
              y: 100,
            }}
            animate={{
              y: 0,
              transition: {
                delay: 0.9,
                duration: 0.8,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className="text-2xl md:text-4xl xl:text-6xl font-calabassas text-[#4B4838]"
          >
            My heart is yours to hold and cherish for the rest of our days.
          </motion.p>
        </motion.div>
      </div>

      <div className={styles["home__quotes-left-flower"]}>
        <Icon iconName="leftQuotesFlower" />
      </div>

      <div className={styles["home__quotes-right-flower"]}>
        <Icon iconName="rightQuotesFlower" />
      </div>
    </div>
  );
};

export default Quotes;
